import type { EntityType } from "@/schemas/digital-files";
import { cn } from "@/utils/theme";
import { Badge } from "@elaniintc/goes-design-system";
import type { ComponentProps } from "react";

interface EntityStatusBadgeProps extends ComponentProps<typeof Badge> {
  entity: EntityType;
  textSufix?: string;
}

export const EntityStatusBadge = ({
  entity,
  children,
  textSufix = "",
  ...badgeDefaultProps
}: EntityStatusBadgeProps) => {
  const { className } = badgeDefaultProps;
  const statusLower = entity?.status?.toLowerCase() || "draft";
  let badgeProps = {
    variant: "neutral" as
      | "info"
      | "warning"
      | "disabled"
      | "action"
      | "success"
      | "danger"
      | "neutral",
    className: "text-neutral-quiet",
  };

  if (statusLower === "active") {
    badgeProps = { variant: "success", className: `text-success${textSufix}` };
  } else if (statusLower === "draft") {
    badgeProps = { variant: "action", className: `text-action${textSufix}` };
  } else if (statusLower === "inactive") {
    badgeProps = { variant: "neutral", className: `text-body${textSufix}` };
  }

  return (
    <Badge
      size="sm"
      {...badgeDefaultProps}
      {...badgeProps}
      className={cn(className, badgeProps.className)}
    >
      {children}
    </Badge>
  );
};
